import { Box, IconButton, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import CustomDropDown from "../../Components/CustomDropDown/CustomDropDown";
import CustomTextField from "../../Components/CustomTextField/CustomTextField";
import * as Yup from "yup";
import CustomPhoneNumber from "../../Components/CustomPhoneNumber/CustomPhoneNumber";
import CustomSubmitButton from "../../Components/CustomSubmitButton/CustomSubmitButton";
import CustomModal from "../../Components/CustomModel/CustomModel";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../../Config/AxiosInstance";
import APILIST from "../../Config/ApiList";
import { useTimeSheet } from "../../Config/TimeSheetContext";
import { Circles, InfinitySpin } from "react-loader-spinner";
import VerifyLeaderPopModel from "../../Components/VerifyLeadPopModel/VerifyLeadPopModel";
const LeadCreation = () => {
  const navigate = useNavigate();
  const { timeSheetUserDetails, isLoading } = useTimeSheet();
  const [isLeadType, setLeadType] = useState(null);
  const [isBusy, setIsBusy] = useState(false);
  const [openNewLeadModel, setOpenNewLeadModel] = useState(false);
  const [isVerifyLeadList, setIsVerifyLeadList] = useState([]);

  const isLeadTypeList = [
    { id: 1, name: "Client ", label: "Client" },
    { id: 2, name: "Employee", label: "Employee" },
  ];
  useEffect(() => {
    getLeadVerifyList();
  }, [])
  const getLeadVerifyList = async () => {
    try {
      const response = await AxiosInstance.get(APILIST.GET_VERIFY_LEAD, {
        params: {
          company_id: timeSheetUserDetails?.Company_details[0]?.id,
        },
      });
      if (response && response?.data?.s) {
        setIsVerifyLeadList(response?.data?.r);
        if (response?.data?.r?.length > 0) {
          handleClickPlaysound();
        }
      } else {
        setIsVerifyLeadList([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleClickWebViewClose = () => {
    try {
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('closeWebView');
      } else {
        console.warn('Flutter InAppWebView not found');
      }
    } catch (error) {
      console.error('Error closing WebView:', error);
    }
  };
  const handleClickPlaysound = () => {
    try {
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('playsound');
      } else {
        console.warn('Flutter playsound not found');
      }
    } catch (error) {
      console.error('Error playsound:', error);
    }
  };
  const formik = useFormik({
    initialValues: {
      lead_type: "",
      contact_name: "",
      phone_Number: "",
      phno_cc: "",
    },
    validationSchema: Yup.object().shape({
      contact_name: Yup.string().required("Contact name is required"),
      phone_Number: Yup.string()
        .required("Phone number is required")
        .min(9, "Phone number must be at least digits"),
      lead_type: Yup.mixed()
        .test("is-not-zero", "Lead type is required", (value) => value !== null)
        .required("Lead type is required!"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsBusy(true);
      try {
        const formData = new FormData();
        formData.append(
          "company_id",
          timeSheetUserDetails?.Company_details[0]?.id
        );
        formData.append("caregiver_id", timeSheetUserDetails?.user_details?.id);
        formData.append("type", values?.lead_type);
        formData.append("name", values?.contact_name);
        formData.append("phno_cc", values.phno_cc);
        formData.append("phno", values.phone_Number);
        const response = await AxiosInstance.post(
          APILIST.CREATE_LEAD,
          formData
        );
        if (response && response?.data?.s) {
          resetForm();
          setIsBusy(false);
          setOpenNewLeadModel(true);
          handleClickPlaysound();
        }
      } catch (error) {
        setIsBusy(false);
      } finally {
        setIsBusy(false);
      }
    },
  });
  return isLoading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: { xs: "100%" },
        minHeight: "100vh",
        background: 'rgba(13, 18, 41, 1)',
      }}
    >
      <InfinitySpin
        visible={true}
        width="200"
        color="#4fa94d"
        ariaLabel="infinity-spin-loading"
      />
    </Box>
  ) : (
    <Fragment>
      {isVerifyLeadList && isVerifyLeadList?.map((lead, index) => (
        <VerifyLeaderPopModel
          key={lead?.id || index}
          lead={lead}
          onClose={() => {
            setIsVerifyLeadList(prev => prev.filter(item => item.id !== lead.id));
          }}
        />
      ))}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: { xs: "100%" },
          minHeight: "100vh",
          background: "rgba(13, 18, 41, 1)",
          position: "relative",
        }}
      >
        {isBusy && <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "100%" },
            minHeight: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            zIndex: 100
          }}
        >
          <Circles
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </Box>}<>
          <Box
            sx={{
              background: "rgba(37, 42, 62, 1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "fixed",
              top: "0px",
              left: "0px",
              right: "0px",
              padding: "10px 15px",
              boxSizing: "border-box",
              zIndex: "10",
              width: "100%",
            }}
          >
            <Box
              sx={{
                width: "10%",
              }}
            >
              <IconButton
                sx={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "50%",
                  background: "rgba(59, 63, 81, 1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  outline: "none",
                  border: "none",
                  cursor: "pointer",
                  ":hover": {
                    background: "rgba(59, 63, 81, 1)",
                  },
                }}
                onClick={handleClickWebViewClose}
              >
                <img
                  src="/back-arrow.webp"
                  alt="back-arrow"
                  style={{
                    width: "18px",
                    height: "18px",
                  }}
                />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "auto",
                flex: 1,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#ffffff",
                  fontSize: "20px",
                  fontWeight: "600",
                  fontFamily: "Poppins",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                Lead Creation
              </Typography>
            </Box>
            <Box
              sx={{
                width: "10%",
              }}
            ></Box>
          </Box>
          <Box
            sx={{
              minHeight: "100vh",
              width: "100%",
              maxWidth: "100%",
            }}
          >
            <Box
              sx={{
                width: "100%",
                paddingTop: "62px",
                boxSizing: "border-box",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'column',
                height: '100vh'
              }}
            >
              {" "}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  formik.handleSubmit();
                  return false;
                }}
                style={{
                  width: "100%",
                  padding: "20px 15px 0px 15px",
                  boxSizing: "border-box",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gridGap: "10px",
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <CustomDropDown
                    sx={{ height: "60px" }}
                    placeholder={"Lead Type"}
                    menuList={isLeadTypeList}
                    value={isLeadType}
                    name={"lead_type"}
                    onChange={(e) => {
                      setLeadType(e.target.value);
                      formik.setFieldValue("lead_type", e.target.value);
                    }}
                    isLoading={isLoading}
                    getLabel={(item) => item?.name}
                    errors={
                      formik?.touched?.lead_type && formik?.errors?.lead_type
                    }
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <CustomTextField
                    label="Contact Name"
                    type="text"
                    placeholder="Contact Name"
                    name="contact_name"
                    value={formik.values.contact_name}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    isLoading={isLoading}
                    errors={
                      formik.touched.contact_name && formik.errors.contact_name
                    }
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <CustomPhoneNumber
                    placeholder="Phone Number"
                    name="phone_Number"
                    country={"us"}
                    value={formik.values.phno_cc + formik.values.phone_Number}
                    errors={
                      formik.touched.phone_Number && formik.errors.phone_Number
                    }
                    onChange={(value, country) => {
                      const countryCodeLength = country.dialCode.length;
                      const phno_cc = value.slice(0, countryCodeLength);
                      const phno = value.slice(countryCodeLength);
                      formik.setFieldValue("phone_Number", phno);
                      formik.setFieldValue("phno_cc", phno_cc);
                    }}
                    isLoading={isLoading}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <CustomSubmitButton
                    type="submit"
                    btnTitle="Submit"
                    loading={isLoading}
                  />
                </Box>
              </form>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  padding: "15px",
                  gridGap: "10px",
                  boxSizing: "border-box",
                  background: "rgba(11, 17, 45, 1)",
                  //   position: 'fixed',
                  //   top: '0px',
                  //   left: '0px',
                  zIndex: "10",
                }}
              >
                {" "}
                <CustomSubmitButton
                  type="button"
                  btnTitle="Lead Status"
                  onSubmit={() => navigate("/create-daily-sheet")}
                />
                <CustomSubmitButton
                  type="button"
                  btnTitle="leaderboard"
                  onSubmit={() => navigate("/leader-board")}
                />
              </Box>
              {openNewLeadModel && (
                <CustomModal
                  message="New Lead Created Successfully!"
                  onClose={() => setOpenNewLeadModel(false)}
                />
              )}
            </Box>
          </Box>
        </>
      </Box>
    </Fragment>
  );
};

export default LeadCreation;
